<template>
  <PropertyOnboardingStep
    :is-next-button-disabled="!description || isGeneratingDescription"
    :next-button-text="'Create Listing'"
    :submit="submit"
  >
    <template v-if="isGeneratingDescription">
      <div class="loading-placeholder">
        <Text variant="h2">We are generating description for you...</Text>
        <LoadingIndicator />
      </div>
    </template>

    <template v-else>
      <Text variant="h2">Here is your property description</Text>
    </template>

    <PropertyDescriptionForm :class="{ loading: isGeneratingDescription }" ref="formRef" />
  </PropertyOnboardingStep>
</template>

<script setup lang="ts">
import { until } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';

import { LoadingIndicator, Text } from '@tallo/design-system';
import { PropertyDescriptionForm, usePropertyStore } from '@tallo/investor/property';
import { PropertyStatus } from '@tallo/property';

import PropertyOnboardingStep from '../property-onboarding-step.vue';

const propertyStore = usePropertyStore();
const { isLoading } = storeToRefs(usePropertyStore());
const formRef = ref<InstanceType<typeof PropertyDescriptionForm>>();
const description = computed(() => formRef.value?.form.fields.description);
const isGeneratingDescription = computed(() => formRef.value?.isGeneratingDescription);

async function submit() {
  await propertyStore.saveStatus(PropertyStatus.READY_FOR_LISTING);
  await formRef.value?.save();
}

(async function init() {
  await until(isLoading).toBe(false);

  if (!description.value) {
    formRef.value?.generateDescription();
  }
})();
</script>

<style scoped lang="scss">
h2 {
  margin-bottom: var(--t-spacing-lg);
}

.loading-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading {
  display: none;
}
</style>
